import script from "./PageComposition.vue?vue&type=script&setup=true&lang=js"
export * from "./PageComposition.vue?vue&type=script&setup=true&lang=js"

import "./PageComposition.vue?vue&type=style&index=0&id=ec1e009c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec1e009c"]])

export default __exports__